import { useState, useEffect, useCallback } from "react";
import { SplitButton } from 'primereact/splitbutton';
import download from 'downloadjs';

import CardSeplag from "../../components/CardSeplag/index";
import TableSeplag from "../../components/TableSeplag";
import RotuloSeplag from '../../components/RotuloSeplag';
import CardExibirPDF from '../../components/CardExibirPDF';
import CertidaoView from './certidaoView'

import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputMask } from 'primereact/inputmask';

import { useFormik } from "formik";


import ModalValidarBeneficiario from './modalValidarBeneficiario'
import ModalAutenticar from "./modalAutenticar";
import ModalBloqueioDesbloqueio from "./modalBloqueioDesbloqueio";

import { useHistory } from 'react-router-dom'
import { imprimirAll as imprimirPDF } from '../../service/ConsultarCertidoesAtivas';



import {
  pesquisarAllAtivas as pesquisarCertidoesAtivas,
  bucaPersonalizada as filtrarCertidoesAtivas,
  imprimirUmaCartuladeCredito,
  exportarAllAtivas,
  consultaCertidoesAtivas,
} from "../../service/ConsultarCertidoesAtivas";


import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

// import { useLocation } from 'react-router'
import { buscarPorCodigo } from "../../service/certidao";
import CertidoesAtivasLoader from "./CertidoesAtivasLoader";
import { useSelector, useDispatch } from "react-redux";
import usePermissions from "../../hooks/usePermissions";

const camposTabela = [
  { titulo: "Beneficiário", nome: "nomePessoa" },
  { titulo: "Tipo", nome: "nomeTipoCertidao" },
  { titulo: "Nº Certidão de Crédito", nome: "numrCertidao" },
  { titulo: "Data Emissão", nome: "dataEmissao" },
  { titulo: "CPF", nome: "numrCpfTitular" },
  { titulo: "Matrícula", nome: "numrMatricula" },
  // { titulo: "Situação", nome: "situacaoDescricao" },
];

const pageableApi = {
  content: [],
  totalElements: 0
}

const Index = () => {

  const dispatch = useDispatch();
  // const arrayPermission = usePermissions({ nomeTela: 'CERTIDOESATIVA' })
  const filterConsultaCertidaoAtiva = useSelector((state) =>
    state.filterConsultaCertidaoAtivasReducer);

  const count = useSelector((state) => state.counterRequestReducer.counterRequest)
  const isLoading = count > 0

  const [dataCertidoesAtivas, setDataCertidoesAtivas] = useState([]);

  const [activeImprimirUnico, setActiveImprimirUnico] = useState(false);

  const [base64Imprimir, setBase64Imprimir] = useState('');
  // const [viewDetalhes, setViewDetalhes] = useState(false);

  const [isValidarBeneficiario, setIsValidarBeneficiario] = useState(false);
  const [isAutenticar, setIsAutenticar] = useState(false);
  const [isBloqueioDesbloqueio, setIsBloqueioDesbloqueio] = useState(false);

  const [isVisualizar, setIsVisualizar] = useState(false);
  const [certidaoSelected, setCertidaoSelected] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);

  const [certidoesApi, setCertidoesApi] = useState(pageableApi)

  let history = useHistory();

  const { pagina, row, filter } = filterConsultaCertidaoAtiva


  const items = [
    // {
    //   label: 'Validar Beneficiário',
    //   icon: 'pi pi-check-circle',
    //   permissao: 'BENEFICIAR',
    //   command: (parm) => {
    //     let { item } = parm
    //     setIsValidarBeneficiario(true);
    //     setCertidaoSelected(item.certidaoSelected)
    //   }
    // },
    // {
    //   label: 'Autenticar',
    //   icon: 'pi pi-key',
    //   permissao: 'AUTENTICAR',
    //   command: (parm) => {
    //     let { item } = parm;
    //     setIsAutenticar(true);
    //     setCertidaoSelected(item.certidaoSelected)
    //   }
    // },
    // {
    //   label: 'Bloquear',
    //   icon: 'pi pi-lock',
    //   permissao: 'BLOQUEAR',
    //   command: (parm) => {
    //     let { item } = parm;
    //     setIsBloqueioDesbloqueio(true);
    //     setCertidaoSelected(item.certidaoSelected)
    //   }
    // },
    // {
    //   label: 'Compensação',
    //   icon: 'pi pi-plus-circle',
    //   command: (parm) => {
    //     let { item } = parm;
    //     history.push(`/certidao/compensacao/${item.certidaoSelected.idenCertidao}`)
    //   }
    // },
    {
      label: 'Quitação',
      permissao: 'QUITAR',
      icon: 'pi pi-minus-circle',
      command: (parm) => {
        let { item } = parm;
        history.push(`/certidao/quitacao/${item.certidaoSelected.idenCertidao}`)
      }
    },
    // {
    //   label: 'Cancelar',
    //   permissao: 'CANCELAR',
    //   icon: 'pi pi-times-circle',
    //   command: () => {
    //     window.location.hash = "/fileupload"
    //   }
    // },
    {
      label: 'Imprimir',
      icon: 'pi pi-print',
      command: (parm) => {
        let { item } = parm;
        onImpressaoCartulaCredito(item.certidaoSelected);
      }
    }
  ];

  const reduxDispatch = (parmFiltro, pagina = 0, row = 10) => {
    parmFiltro.numrCpfTitular = parmFiltro.numrCpfTitular === 0 ? 0 : parmFiltro.numrCpfTitular.replace(/[^\w\s]|_/g, "")

    dispatch({
      type: "SETFILTER_CONSULTA_CERTIDAO_ATIVA",
      value: {
        filter: { ...parmFiltro },
        pagina,
        row
      }
    });
  }


  const handleBusca = (payload, page, rows) => {

    let paginacao = `size=${rows}&page=${page}`;

    filtrarCertidoesAtivas(payload, paginacao).then(res => {
      setCertidoesApi(res)
      reduxDispatch(formik.values, page, rows, res)
    })
  }


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: consultaCertidoesAtivas,
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: async (data) => {

      let payload = {
        nomePessoa: data.nomePessoa,
        numrCpfTitular: data.numrCpfTitular === 0 ? null : data.numrCpfTitular.replace(/[^\w\s]|_/g, ""),
        numrMatricula: data.numrMatricula === undefined ? null : data.numrMatricula,
        numrCertidao: data.numrCertidao === undefined ? null : data.numrCertidao,
        dataQuitacao: data.dataQuitacao === undefined || data.dataQuitacao === false ? data.dataQuitacao = null : data.dataQuitacao,
        flagSituacao: data.flagSituacao === undefined || data.flagSituacao === false || data.flagSituacao === null ? data.flagSituacao = null : 2,
        dataAutenticacao: data.dataAutenticacao === undefined || data.dataAutenticacao === false ? data.dataAutenticacao = null : data.dataAutenticacao,
      }


      handleBusca(payload, pagina, row)


    },
  });


  useEffect(() => {

    formik.setValues(filter);

    let payload = {
      nomePessoa: filter.nomePessoa,
      numrCpfTitular: filter.numrCpfTitular === 0 ? null : filter.numrCpfTitular.replace(/[^\w\s]|_/g, ""),
      numrMatricula: filter.numrMatricula === undefined ? null : filter.numrMatricula,
      numrCertidao: filter.numrCertidao === undefined ? null : filter.numrCertidao,
      dataQuitacao: filter.dataQuitacao === undefined || filter.dataQuitacao === false ? filter.dataQuitacao = null : filter.dataQuitacao,
      flagSituacao: filter.flagSituacao === undefined || filter.flagSituacao === false || filter.flagSituacao === null ? filter.flagSituacao = null : 2,
      dataAutenticacao: filter.dataAutenticacao === undefined || filter.dataAutenticacao === false ? filter.dataAutenticacao = null : filterConsultaCertidaoAtiva.filter.dataAutenticacao,
    }

    handleBusca(payload, pagina, row)

  }, []);

  const onImpressaoCartulaCredito = (rowData) => {

    let data = {
      numrCpfTitular: rowData.numrCpfTitular,
      numrCertidao: rowData.numrCertidao,
    }

    imprimirUmaCartuladeCredito(data).then((res) => {
      setBase64Imprimir('data:application/pdf;base64,' + res.dadosRelatorioBase64)
    });

    setActiveImprimirUnico(true);
  }

  const onExportarCertidoesAtivas = async () => {
    // setActiveExportarExcel(true);
    // setActiveImprimir(false);

    let payload = {
      nomePessoa: formik.values.nomePessoa ? formik.values.nomePessoa : "",
      numrCertidao: formik.values.numrCertidao ? formik.values.numrCertidao : "",
      numrCpfTitular: formik.values.numrCpfTitular === 0 || formik.values.numrCpfTitular === "" ? "" : formik.values.numrCpfTitular.replace(/[^\w\s]|_/g, ""),
      numrMatricula: formik.values.numrMatricula ? formik.values.numrMatricula : null,
      dataQuitacao: formik.values.dataQuitacao ? 1 : 0,
      dataAutenticacao: formik.values.dataAutenticacao ? formik.values.dataAutenticacao : false,
      flagSituacao: formik.values.flagSituacao ? 2 : null,
    }

    const response = await exportarAllAtivas(payload);

    download(`data:application/excel;base64,${response.dadosRelatorioBase64}`, response.nomeArquivo, "application/excel");

  }

  async function showModalFiltrarCertidoesAtivas() {

    let payload = {
      nomePessoa: formik.values.nomePessoa ? formik.values.nomePessoa : "",
      numrCertidao: formik.values.numrCertidao ? formik.values.numrCertidao : "",
      numrCpfTitular: formik.values.numrCpfTitular === 0 || formik.values.numrCpfTitular === "" ? "" : formik.values.numrCpfTitular.replace(/[^\w\s]|_/g, ""),
      numrMatricula: formik.values.numrMatricula ? formik.values.numrMatricula : null,
      dataQuitacao: formik.values.dataQuitacao ? 1 : 0,
      dataAutenticacao: formik.values.dataAutenticacao ? formik.values.dataAutenticacao : false,
      flagSituacao: formik.values.flagSituacao ? 2 : null,

    }

    const { dadosRelatorioBase64 } = await imprimirPDF(payload);
    setBase64Imprimir('data:application/pdf;base64,' + dadosRelatorioBase64);
    setActiveImprimirUnico(true);

  }

  const botoesAcoes = (rowData) => {

    function filtrar(e) {
      return true//e.permissao ? arrayPermission.includes(e.permissao) : true;
    }

    let modelItems = items
      .filter(filtrar)
      .map(element => {
        let disabled = false
        let label = element.label

        if (element.label === 'Validar Beneficiário') {
          disabled = rowData.flagValidacaoBeneficiario === 'S'
        }

        if (element.label === 'Autenticar') {
          disabled = rowData.flagAutenticacao === 'S'
        }

        if (element.label === 'Bloquear') {
          label = rowData.flagSituacao === 'BLOQUEADA' ? "Desbloquear" : "Bloquear"
        }

        if (element.label === 'Cancelar') {
          disabled = true
        }

        return {
          ...element,
          certidaoSelected: rowData,
          disabled,
          label
        }
      })

    const handleVisualizar = () => {

      buscarPorCodigo(rowData.idenCertidao).then(res => {
        setCertidaoSelected(res)
        setIsVisualizar(true)
      })
    }

    return <>
      <SplitButton
        icon="pi pi-eye"
        model={modelItems}
        onClick={() => handleVisualizar()}></SplitButton>
    </>
  }

  const onHide = () => {
    setCertidaoSelected(null)
    setIsVisualizar(false)
  }

  const onHideValidarBeneficiario = () => {
    setCertidaoSelected(null)
    setIsValidarBeneficiario(false)
  }

  const onHideAutenticar = useCallback(
    () => {
      setCertidaoSelected(null)
      setIsAutenticar(false)
    },
    []
  );

  const onHideBloquearDesbloquear = () => {
    setCertidaoSelected(null)
    setIsBloqueioDesbloqueio(false)
  }

  const atualizarTable = useCallback(
    () => {
      pesquisarCertidoesAtivas().then(res => {
        setCertidoesApi(res)
      });
    },
    []
  );

  const paginacao = (event) => {



    let payload = {
      nomePessoa: formik.values.nomePessoa,
      numrCpfTitular: formik.values.numrCpfTitular === 0 ? null : formik.values.numrCpfTitular.replace(/[^\w\s]|_/g, ""),
      numrMatricula: formik.values.numrMatricula === undefined ? null : formik.values.numrMatricula,
      numrCertidao: formik.values.numrCertidao === undefined ? null : formik.values.numrCertidao,
      dataQuitacao: formik.values.dataQuitacao === undefined || formik.values.dataQuitacao === false ? formik.values.dataQuitacao = null : formik.values.dataQuitacao,
      flagSituacao: formik.values.flagSituacao === undefined || formik.values.flagSituacao === false || formik.values.flagSituacao === null ? formik.values.flagSituacao = null : 2,
      dataAutenticacao: formik.values.dataAutenticacao === undefined || formik.values.dataAutenticacao === false ? formik.values.dataAutenticacao = null : formik.values.dataAutenticacao,
    }


    handleBusca(payload, event.page, event.rows)
  }

  return (
    <CardSeplag title="Certidões de Crédito">
      {
        isLoading && <CertidoesAtivasLoader />
      }

      {
        !isLoading &&

        <form onSubmit={formik.handleSubmit} className="p-col-12">
          <div className="p-col-12 p-grid">

            <div className='p-col-12 ' />
            <RotuloSeplag nome="Beneficiário" cols="12 6 3">
              <InputText
                name="nomePessoa"
                id="nomePessoa"
                onChange={formik.handleChange}
                value={formik.values.nomePessoa}
                style={{ width: '100%' }}
              />
            </RotuloSeplag>

            <RotuloSeplag nome="CPF" cols="12 6 3">
              <InputMask
                name="numrCpfTitular"
                id="numrCpfTitular"
                mask="999.999.999-99"
                style={{ width: '100%' }}
                onChange={formik.handleChange}
                value={formik.values.numrCpfTitular}
              />
            </RotuloSeplag>

            <RotuloSeplag nome="Matrícula" cols="12 6 3">
              <InputNumber
                name="numrMatricula"
                id="numrMatricula"
                onValueChange={formik.handleChange}
                value={formik.values.numrMatricula}
                style={{ width: '100%' }}
              />
            </RotuloSeplag>

            <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6 3">
              <InputText
                name="numrCertidao"
                id="numrCertidao"
                onChange={formik.handleChange}
                value={formik.values.numrCertidao}
                style={{ width: '100%' }}
              />
            </RotuloSeplag>

            <RotuloSeplag cols="12 6 3">
              <Button type="submit" label="Filtrar" icon="pi pi-search" className="p-button-raised p-mr-2" />
            </RotuloSeplag>

          </div>
        </form>
      }


      <TableSeplag
        dados={certidoesApi.content}
        totalRecords={certidoesApi.totalElements}
        camposTabela={camposTabela}
        hasEventoAcao
        onModalSearch
        botoesAcoes={botoesAcoes}
        onPage={paginacao}
        page={pagina}
        rows={row}
        onImprimir={showModalFiltrarCertidoesAtivas}
        onExportar={onExportarCertidoesAtivas}
      />

      {
        activeImprimirUnico &&
        <CardExibirPDF
          onHide={() => setActiveImprimirUnico(false)}
          alturaTela="900"
          // tamanhoTela="980"
          isExibirPDF={activeImprimirUnico}
          stringPDF={base64Imprimir}
        />
      }

      { certidaoSelected && (
        <>

          <Dialog visible={isVisualizar} modal={true} onHide={onHide}>
            <CertidaoView certidao={certidaoSelected} />
          </Dialog>

          {
            isValidarBeneficiario && <ModalValidarBeneficiario
              visible={isValidarBeneficiario}
              certidaoSelected={certidaoSelected}
              onFechar={onHideValidarBeneficiario}
              onSalvar={atualizarTable}
            />
          }

          {
            isAutenticar &&
            <ModalAutenticar
              visible={isAutenticar}
              certidaoSelected={certidaoSelected}
              onFechar={onHideAutenticar}
              onSalvar={atualizarTable}
            />
          }

          {
            isBloqueioDesbloqueio &&
            <ModalBloqueioDesbloqueio
              visible={isBloqueioDesbloqueio}
              certidaoSelected={certidaoSelected}
              onFechar={onHideBloquearDesbloquear}
              onSalvar={atualizarTable}
            />
          }
        </>
      )}

    </CardSeplag>
  );
};

export default Index;
